// extracted by mini-css-extract-plugin
export default {"container":"CodeTabsSection-module_container__Vd7Jt"};